import { render } from "./UserRoutingPage.vue?vue&type=template&id=33b4d378&scoped=true"
import script from "./UserRoutingPage.vue?vue&type=script&lang=js"
export * from "./UserRoutingPage.vue?vue&type=script&lang=js"

import "./UserRoutingPage.vue?vue&type=style&index=0&id=33b4d378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33b4d378"]])

export default __exports__